import html2canvas from "html2canvas";
import useStore from "../store.ts";
import {parsePx} from "./ElementUtils.ts";
import {integrationManager} from "../integrations/IntegrationManager.ts";

export const captureScreenGeneric = async (): Promise<Uint8Array> => {
    const store = useStore();
    const firstKey = Object.keys(store.layoutData)[0];

    const item =
        firstKey
            ? store.components[firstKey.replace("_", "")]
            : undefined;

    let width = window.innerWidth;
    let height = window.innerHeight;

    if (item) {
        width = parsePx(item.props.style.width) * item.scale;
        height = parsePx(item.props.style.height) * item.scale;
    }

    const el = document.getElementById("app");
    if (!el) throw new Error('Element with id "app" not found');

    const canvas = await html2canvas(el as HTMLElement, {
        allowTaint: true,
        useCORS: true,
        width,
        height,
    });

    const blob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(
            (b) => (b ? resolve(b) : reject(new Error("Blob not found"))),
            "image/jpeg"
        );
    });

    const buffer = await blob.arrayBuffer();
    return new Uint8Array(buffer);
};


export const captureScreen = async (device_id: string) => {
    const store = useStore();
    let image: Uint8Array<ArrayBufferLike> | null = null;

    if (integrationManager.hasIntegrated()) {
        await integrationManager.captureScreen(device_id);
        return;
    }

    image = await captureScreenGeneric();
    if (image == null) return;
    await store.socketManager.sendScreenDump(image, device_id);
}
